module.exports = __webpack_public_path__ + "img/lomexin-4.61151c1d.png";